
import { Thermostat } from './thermostat.model';

export class NAThermVaillant extends Thermostat {

    MAX_TIME_BEFORE_UNKNOWN = 6 * 3600;

}
